import React from "react";

const HSpace: React.FC = () => {
  return <div style={{ marginRight: "2px" }} />;
};

export default HSpace;
